import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { TileHeader } from './TileHeader';

export const BodyMetricGraphTile = ({
  graphHeading,
  containerStyle,
  navigation,
  actions,
  graph,
  legendAndIcons,
}) => {
  return (
    <TouchableOpacity style={[styles.container, containerStyle]}
      onPress={() => navigation.navigate('TrackingScanStats')}
    >
      <TileHeader>{graphHeading}</TileHeader>
      <View style={styles.graphLegendContainer}>
        {legendAndIcons.map(({label, icon}) => {
          return <>{icon}{label}</>;
        })}
      </View>
    {graph}
    {actions}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.WHITE,
    paddingHorizontal: defaultScale(16),
    paddingTop: defaultScale(24),
    paddingBottom: defaultScale(16),
    marginTop: defaultScale(12),
  },
  headingContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: defaultScale(11),
    alignItems: 'center',
  },
  graphTileHeading: {
    color: Theme.BLACK,
    ...Theme.textStyle.heading,
  },
  graphLegendContainer: {
    flexDirection: 'row',
    marginBottom: defaultScale(20),
    marginTop: defaultScale(20),
    paddingLeft: defaultScale(3),
  },
});
